package ui.resource.detail

import androidx.compose.runtime.*
import api.*
import common.frontend.api.*
import provider.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*


interface ResourceScope {

    val vm: ResourceVM
    val action: (ResourceVM.Action) -> Unit
    val account: CommonAccountProvider
    val display: CommonDisplayProvider
    val externals: CommonExternalsProvider

    val args: ResourceArgs
    val nav: Navigation
    val login: Io.User

    companion object {
        @Composable
        fun rememberScope(): ResourceScope {
            val nav = LocalNavigation.current
            val account = LocalAccountProvider.current
            val args = LocalNavigationArgs.current.rememberArgs(ResourceArgs::class)
            val vm = nav.viewModel(ResourceVM::class, "${args.companyId}:${args.resourceId}")
            val action = ResourceVM.Action.rememberAction(vm)
            val display = LocalDisplayProvider.current
            val externals = LocalExternalsProvider.current
            return remember {
                object : ResourceScope {
                    override val vm: ResourceVM
                        get() = vm
                    override val action: (ResourceVM.Action) -> Unit
                        get() = action
                    override val account: CommonAccountProvider
                        get() = account
                    override val display: CommonDisplayProvider
                        get() = display
                    override val externals: CommonExternalsProvider
                        get() = externals
                    override val args: ResourceArgs
                        get() = args
                    override val nav: Navigation
                        get() = nav
                    override val login: Io.User
                        get() = account.current!!
                }.also {
                    vm.init(it)
                }
            }
        }
    }

    class Wrapper(
        val canDelete: Boolean,
        val canEdit: Boolean,
        val imageOrVideo: Boolean,
        val title: Pair<String, String>,
        val data: Io.Resource,
        val type: ResourceType = ResourceType[data.type]
    )
}
